module.exports = __webpack_public_path__ + "static/media/115-star.f2f97c71.svg";